export default [
  {
    label: "有限公司",
    value: "2"
  },
  {
    label: "有限责任公司",
    value: "3"
  },
  {
    label: "股份公司",
    value: "4"
  },
  {
    label: "股份有限公司",
    value: "5"
  },
  {
    label: "集团有限公司",
    value: "6"
  },
  {
    label: "（集团）有限公司",
    value: "7"
  },
  {
    label: "集团股份有限公司",
    value: "8"
  },
  {
    label: "（集团）股份有限公司",
    value: "9"
  },
  {
    label: "合伙企业（普通合伙）",
    value: "10"
  },
  {
    label: "合伙企业（特殊普通合伙）",
    value: "11"
  },
  {
    label: "合伙企业（有限合伙）",
    value: "12"
  }
];
